export const isDateOnOrAfterToday = (date: string) => {
    return new Date(new Date(date).toDateString()) >= new Date(new Date().toDateString());
};